import { Bonus } from "./Bonus";
import { BonusManager } from "./BonusManager";


export class ActiveBonus {
    /**
     * (RO) Bonus
     */
    get bonus(): Bonus { return this._bonus; }
    private _bonus: Bonus;

    /**
     * Cas aktivace bonusu
     */
    private _actTime: number;

    /**
     * (RO) Zbyvajici cas, po ktery bude bonus jeste aktivni
     */
    get remTime(): number { return this._bonus.duration - (BonusManager.ACT_BONUS_TIMER.time - this._actTime); }

    /**
     * (RO) Prubeh platnosti bonusu od 1 do 0
     */
    get progress(): number { return 1 - ((BonusManager.ACT_BONUS_TIMER.time - this._actTime) / this._bonus.duration); }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    init(bonus: Bonus): ActiveBonus {
        this._bonus = bonus;
        this._actTime = BonusManager.ACT_BONUS_TIMER.time;

        return this;
    }

    //-------------------------------------------------------------------------
    /**
     * Nastavi cas sebrani na aktualni cas
     */
    //-------------------------------------------------------------------------
    resetActTime(): void {
        this._actTime = BonusManager.ACT_BONUS_TIMER.time;
    }
}